import React from "react";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import GlobalConstants from "@constants";
import useGetSupportItemsPermission from "@features/unified-side-nav-feature/hooks/useGetSupportNavPermission";

const supportNewRequestPath =
  GlobalConstants.knownPaths.supportCenter_NewRequest;

const supportRequestsPath = GlobalConstants.knownPaths.supportCenter_Requests;
const supportServiceReportPath = "/services/reports";
const supportMyDevicesPath = "/support-center/mydevices";
const supportServicesContractsPath = "/services/contracts";
const supportBillingPath = "/services/billing";
const supportServiceEngagementsPath = "/services/service-engagements";

export function useGetSupportNavItems() {
  const {
    showSupportSection,
    showNewRequest,
    showRequests,
    showServiceReport,
    showMyDevices,
    showContracts,
    showBilling,
    showServiceEngagements,
  } = useGetSupportItemsPermission();

  return [
    {
      id: "support",
      type: "Dashboard",
      displayName: "Services & Support",
      visible: showSupportSection,
      icon: <LocalHospitalIcon />,
      path: "/support",
      children: [
        {
          id: "support-new-request",
          type: "Link",
          displayName: "New Request",
          visible: showNewRequest,
          path: supportNewRequestPath,
        },
        {
          id: "support-requests",
          type: "Link",
          displayName: "Requests",
          visible: showRequests,
          path: supportRequestsPath,
        },
        {
          id: "support-service-engagements",
          type: "Link",
          displayName: "Service Engagements",
          visible: showServiceEngagements,
          path: supportServiceEngagementsPath,
        },
        {
          id: "support-reports",
          type: "Link",
          displayName: "Service Report",
          visible: showServiceReport,
          path: supportServiceReportPath,
        },
        {
          id: "support-my-devices",
          type: "Link",
          displayName: "My Devices",
          visible: showMyDevices,
          path: supportMyDevicesPath,
        },
        {
          id: "support-contracts",
          type: "Link",
          displayName: "Contracts",
          visible: showContracts,
          path: supportServicesContractsPath,
        },
        {
          id: "support-billing",
          type: "Link",
          displayName: "Billing",
          visible: showBilling,
          path: supportBillingPath,
        },
      ],
    },
  ];
}
